import React from "react";
import {formLayout} from "./constant/css";
import {
    getLanguage,
    validateMessages
} from "./source/js/common";
import AisinoForm from "./baseComponent/form/AisinoForm";
import AisinoButton from "./baseComponent/button/AisinoButton";
import AisinoButtonArea from "./common/area/AisinoButtonArea";
import CloseSquareOutlined from "@ant-design/icons/es/icons/CloseSquareOutlined";
import {AisinoFormItem, AisinoInput} from "./baseComponent/form";
import Button from "antd/es/button";
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "./baseComponent/rowAndCol/AisinoCol";
import {YesOrNo} from "./dictionary";
import FormItemDictRadio from "./common/form/radio/FormItemDictRadio";
import FormItemDatePicker from "./common/form/datePicker/FormItemDatePicker";
import {
    aisinoCancelConfirmModal,
    aisinoErrorModal,
    aisinoSaveConfirmModal,
    aisinoSaveSuccessModal
} from "./common/modal/AisinoModalMethod";
import {Modal} from "antd";
import moment from "moment";
import {FormItemInput} from "./common/form";
import {post} from "./common/utils/http";
import {SaveOutlined} from "@ant-design/icons";

const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

class AccountSecurity extends React.Component{
    constructor(props){
        super(props);
        this.state={
            pageFlag:'modify',
            authorizeCodeValue:'',
            callbackFun:'',
            businessDiv:'none'
        }
        this.dateFormat = "YYYY-MM-DD HH:mm:ss";
    }
    componentDidMount() {
        this.loadAccountSecurity();
    }

    loadAccountSecurity(){
        post("aisino/myProfile/loadAccountSecurity",{},true).then(response=>{
            // console.log("load",response);
            if(response != null){
                if(YesOrNo.YES === response.enableAuthorizeCode){
                    this.refs.securityForm.setFieldsValue({
                        id:response.id,
                        enableAuthorizeCode:YesOrNo.YES,
                        authorizeCode:response.authorizeCode,
                        createDate:moment(response.createDate,this.dateFormat),
                    });
                    this.setState({
                        authorizeCodeValue:response.authorizeCode,
                        businessDiv:"block"
                    });
                }
                else{
                    this.refs.securityForm.setFieldsValue({
                        id:response.id,
                        authorizeCode:"",
                        createDate:""
                    });
                }
            }
        });

    }
    hideAuthorize(){
        // this.refs.securityForm.resetFields();
        this.refs.securityForm.setFieldsValue({
            createDate:"",
            authorizeCode:"",
            enableAuthorizeCode:YesOrNo.NO,
        });
        this.setState({
            authorizeCodeValue:"",
            businessDiv:"none"
        });

    }
    changeRadio = (e) => {
        const that = this;
        if (e.target.value === '101') {
            this.loadAccountSecurity();
            this.setState({
                businessDiv:"block"
            });

        }else if(e.target.value === '102') {
            this.hideAuthorize();
        }
    }
    close = ()=>{
        if(!this.props.login){
            aisinoCancelConfirmModal(()=>{
                this.refs.securityForm.setFieldsValue({
                    enableAuthorizeCode:YesOrNo.NO,
                    authorizeCode:"",
                    createDate:"",
                });
                this.setState({authorizeCodeValue:""});
                this.props.handleSecurityClose();
            })
        }else{
            Modal.confirm({
                title:commonLan.confirmTitle.label,
                content: commonLan.cancelConfirm.label,
                okText:commonLan.okButton.label,
                cancelText:commonLan.cancelButton.label,
                onOk:()=>{
                    this.props.handleSecurityClose();
                }
            });
        }
    }
    saveAuthorizeCode= async ()=>{
        try{
            let values = await this.refs.securityForm.getFieldsValue();
            if(YesOrNo.YES === this.refs.securityForm.getFieldValue("enableAuthorizeCode")){
                values = await this.refs.securityForm.validateFields();
                values.createDate = values.createDate.format("YYYY-MM-DD HH:mm:ss");
            }
            else{
                values.id = this.refs.securityForm.getFieldValue("id");
            }
            // console.log(values);
            const that = this;
            aisinoSaveConfirmModal(function (){
                post('aisino/myProfile/saveOrUpdateAccountSecurity',values,true).then(response=>{
                    // console.log("save",response)
                    if(response != null){
                        aisinoSaveSuccessModal(function (){
                            that.props.handleSecurityClose();
                        });
                    }
                    else{
                        aisinoErrorModal();
                    }
                });

            });


        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    }
    generateKey = ()=>{
        let key = '';
        // 循环32次，每次生成一个随机的十六进制字符
        for (let i = 0; i < 32; i++) {
            // 生成一个0到15之间的随机数
            let randomNum = Math.floor(Math.random() * 16);
            // 根据随机数选择对应的十六进制字符
            // 0-9对应'0'-'9'，10-15对应'a'-'f'
            let hexChar = (randomNum < 10) ? randomNum.toString() : String.fromCharCode(randomNum + 87); // 87 = 'a'.charCodeAt(0) - 10
            // 将生成的十六进制字符添加到密钥字符串中
            key += hexChar;
        }
        this.refs.securityForm.setFieldsValue({
            authorizeCode:key,
            createDate:moment(),
        });
        this.setState({authorizeCodeValue:key});
    }
    render() {
        const buttonModules=[
            <AisinoButton type="primary" icon={<SaveOutlined/>} onClick={this.saveAuthorizeCode} >{commonLan.saveButton.label}</AisinoButton>,
            <AisinoButton htmlType="button" icon={<CloseSquareOutlined/>} onClick={this.close}>{commonLan.cancelButton.label}</AisinoButton>,
        ];
        return (
            <AisinoForm {...formLayout} validateMessages={validateMessages()}
                        name="security-ref" ref="securityForm" >
                <AisinoRow>
                    <AisinoCol span={24}>
                        <FormItemInput name={"id"} hidden={true}></FormItemInput>
                        <FormItemDictRadio horizontal="1"  initialValue={YesOrNo.NO} typecode={YesOrNo.CODE}
                                           label={loginLan.enableAuthorizeCode} name={"enableAuthorizeCode"}
                                           onChange={(e)=>this.changeRadio(e)}/>
                    </AisinoCol>
                </AisinoRow>
                <div id="businessDiv" style={{display:this.state.businessDiv}}>
                    <AisinoRow>
                        <AisinoCol span={24}>
                            <AisinoFormItem label={loginLan.authorizeCode} name={"authorizeCode"} rules={[{required: true}]}>
                                <AisinoInput.Group compact style={{
                                    display: 'flex',  // 明确 Flex 布局（防止组件默认样式失效）
                                    flexWrap: 'nowrap',  // 关键：禁止换行，强制同行
                                    width: '100%'  // 让容器占满 FormItem 宽度，避免父容器挤压
                                }}>
                                    <AisinoInput value={this.state.authorizeCodeValue} style={{ flex: 1, minWidth: '120px' }}  disabled={true} />
                                    <Button htmlType="button" style={{ minWidth: '80px' }} onClick={(e)=>this.generateKey()}>{loginLan.generate}</Button>
                                </AisinoInput.Group>
                            </AisinoFormItem>
                        </AisinoCol>
                    </AisinoRow>
                    <AisinoRow >
                        <AisinoCol span={24}>
                            <FormItemDatePicker showTime name="createDate" label={loginLan.generateTime} disabled={true}/>
                        </AisinoCol>
                    </AisinoRow>
                    <div style={{margin:"10px 0px 15px 0px",fontSize:"8pt",}}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{loginLan.securityDescription}
                    </div>
                </div>
                <div className="pageBottomButtonBg">
                    <AisinoButtonArea buttonModules={buttonModules} style={{justifyContent: "center"}}/>
                </div>
            </AisinoForm>
        );
    }
}
export default AccountSecurity;
